var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"bg-default-card",attrs:{"header":_vm.uLang('app.duplicate_enrolment'),"header-tag":"h4"}},[(_vm.relation && _vm.original)?_c('trajectory-enrolment-form',{attrs:{"relation":_vm.relation,"prefill":_vm.prefill,"override-endpoint":_vm.overrideEndpoint}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }